
    /*
    * Auto Build of Registry
    */

    var registry = require("../../uam/registry.js")("uat.elements");
    
        registry.add(require("./animations/ua.a.conic.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.a.count"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.a.fade50"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.a.typeon"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("chart.js"));
        registry.add(require("./elements/checkout.preview.js"));
        registry.add(require("./elements/email.button.js"));
        registry.add(require("./elements/email.card.js"));
        registry.add(require("./elements/email.code.js"));
        registry.add(require("./elements/email.divider.js"));
        registry.add(require("./elements/email.footer.js"));
        registry.add(require("./elements/email.greeting.js"));
        registry.add(require("./elements/email.header.js"));
        registry.add(require("./elements/email.image.js"));
        registry.add(require("./elements/email.list.js"));
        registry.add(require("./elements/email.role.list.js"));
        registry.add(require("./elements/email.section.js"));
        registry.add(require("./elements/email.security.js"));
        registry.add(require("./elements/email.spacer.js"));
        registry.add(require("./elements/email.text.js"));
        registry.add(require("./elements/email.uajson.js"));
        registry.add(require("./elements/email.unsubscribe.js"));
        registry.add(require("./elements/home.flashshow.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("lottie.dot"));
        registry.add(require("./elements/pages.album.js"));
        registry.add(require("./elements/pages.author.profile.js"));
        registry.add(require("./elements/pages.blog.index.js"));
        registry.add(require("./elements/pages.blog.js"));
        registry.add(require("./elements/pages.blog.post.js"));
        registry.add(require("./elements/pages.documentation.js"));
        registry.add(require("./elements/pages.event.js"));
        registry.add(require("./elements/pages.landing.js"));
        registry.add(require("./elements/pages.meta.js"));
        registry.add(require("./elements/pages.news.article.js"));
        registry.add(require("./elements/pages.page.js"));
        registry.add(require("./elements/pages.podcast.episode.js"));
        registry.add(require("./elements/pages.podcast.js"));
        registry.add(require("./elements/pages.preview.album.js"));
        registry.add(require("./elements/pages.preview.author.profile.js"));
        registry.add(require("./elements/pages.preview.blog.index.js"));
        registry.add(require("./elements/pages.preview.blog.post.js"));
        registry.add(require("./elements/pages.preview.documentation.js"));
        registry.add(require("./elements/pages.preview.event.js"));
        registry.add(require("./elements/pages.preview.js"));
        registry.add(require("./elements/pages.preview.landing.js"));
        registry.add(require("./elements/pages.preview.news.article.js"));
        registry.add(require("./elements/pages.preview.podcast.episode.js"));
        registry.add(require("./elements/pages.preview.podcast.js"));
        registry.add(require("./elements/pages.preview.product.js"));
        registry.add(require("./elements/pages.preview.recipe.js"));
        registry.add(require("./elements/pages.preview.release.note.js"));
        registry.add(require("./elements/pages.preview.song.js"));
        registry.add(require("./elements/pages.preview.staff.profile.js"));
        registry.add(require("./elements/pages.preview.standard.js"));
        registry.add(require("./elements/pages.preview.video.js"));
        registry.add(require("./elements/pages.preview.web.page.js"));
        registry.add(require("./elements/pages.product.js"));
        registry.add(require("./elements/pages.recipe.js"));
        registry.add(require("./elements/pages.release.note.js"));
        registry.add(require("./elements/pages.song.js"));
        registry.add(require("./elements/pages.staff.profile.js"));
        registry.add(require("./elements/pages.standard.js"));
        registry.add(require("./elements/pages.video.js"));
        registry.add(require("./elements/pages.web.page.js"));
        registry.add(require("./elements/special.body.js"));
        registry.add(require("./elements/ua.a.incenter.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.access"));
        registry.add(require("./elements/ua.accordion.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.address"));
        registry.add(require("./elements/ua.address.list.js"));
        registry.add(require("./elements/ua.address.show.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.agreement"));
        registry.add(require("./elements/ua.alert.js"));
        registry.add(require("./elements/ua.appbar.js"));
        registry.add(require("./elements/ua.attr.data.goto.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.breadcrumb"));
        registry.add(require("./elements/ua.button.toggle.js"));
        registry.add(require("./elements/ua.card.simple.js"));
        registry.add(require("./elements/ua.carousel.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.checkbox"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.code"));
        registry.add(require("./elements/ua.collection.order.js"));
        registry.add(require("./elements/ua.dashboard.item.js"));
        registry.add(require("./elements/ua.dashboard.list.js"));
        registry.add(require("./elements/ua.dashboard.sidebar.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.devmode"));
        registry.add(require("./elements/ua.dialog.getdirections.js"));
        registry.add(require("./elements/ua.dialog.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.doc.email"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.doc.simple"));
        registry.add(require("./elements/ua.element.error.js"));
        registry.add(require("./elements/ua.element.placeholder.js"));
        registry.add(require("./elements/ua.element.scripts.js"));
        registry.add(require("./elements/ua.element.serverNotSupported.js"));
        registry.add(require("./elements/ua.element.validation.error.js"));
        registry.add(require("./elements/ua.error.stacktrace.line.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.fields.type.select"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.file.preview"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.file.upload"));
        registry.add(require("./elements/ua.filter.js"));
        registry.add(require("./elements/ua.footer.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.footnote"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.footnotes"));
        registry.add(require("./elements/ua.fs.center.js"));
        registry.add(require("./elements/ua.fs.col.js"));
        registry.add(require("./elements/ua.fs.image.js"));
        registry.add(require("./elements/ua.fs.module.js"));
        registry.add(require("./elements/ua.fs.scrollup.js"));
        registry.add(require("./elements/ua.fs.sidebyside.image.js"));
        registry.add(require("./elements/ua.fs.sidebyside.sticky.js"));
        registry.add(require("./elements/ua.fs.simple.js"));
        registry.add(require("./elements/ua.fs.video.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.getdirections"));
        registry.add(require("./elements/ua.hcard.simple.js"));
        registry.add(require("./elements/ua.header.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.input"));
        registry.add(require("./elements/ua.list.item.js"));
        registry.add(require("./elements/ua.list.js"));
        registry.add(require("./elements/ua.magic.glow.js"));
        registry.add(require("./elements/ua.marquee.js"));
        registry.add(require("./elements/ua.nav.js"));
        registry.add(require("./elements/ua.navbar.item.js"));
        registry.add(require("./elements/ua.navbar.js"));
        registry.add(require("./elements/ua.navbar.menu.js"));
        registry.add(require("./elements/ua.none.js"));
        registry.add(require("./elements/ua.notification.icon.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.phone"));
        registry.add(require("./elements/ua.platform.video.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.preview.access"));
        registry.add(require("./elements/ua.preview.address.js"));
        registry.add(require("./elements/ua.preview.agreement.js"));
        registry.add(require("./elements/ua.preview.boolean.js"));
        registry.add(require("./elements/ua.preview.color.js"));
        registry.add(require("./elements/ua.preview.date.js"));
        registry.add(require("./elements/ua.preview.doc.js"));
        registry.add(require("./elements/ua.preview.input.js"));
        registry.add(require("./elements/ua.preview.json.js"));
        registry.add(require("./elements/ua.preview.phone.js"));
        registry.add(require("./elements/ua.preview.select.multiple.js"));
        registry.add(require("./elements/ua.preview.tags.js"));
        registry.add(require("./elements/ua.preview.text.js"));
        registry.add(require("./elements/ua.quick.bio.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.random"));
        registry.add(require("./elements/ua.repeater.js"));
        registry.add(require("./elements/ua.report.metric.card.js"));
        registry.add(require("./elements/ua.report.panel.js"));
        registry.add(require("./elements/ua.report.view.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.fields.schema.editor"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.scroll.progress"));
        registry.add(require("./elements/ua.scroll.totop.js"));
        registry.add(require("./elements/ua.select.accordion.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.select.color"));
        registry.add(require("./elements/ua.select.datalist.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.select.date"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.select.dropdown"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.select.group"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.select.multiple"));
        registry.add(require("./elements/ua.source.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.switch"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.t"));
        registry.add(require("./elements/ua.tabs.js"));
        registry.add(require("./elements/ua.tags.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.text.bygroup"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.toggle"));
        registry.add(require("./elements/ua.ts.js"));
        registry.add(require("./elements/ua.updater.js"));
registry.add(require("./elements/ua.element.serverNotSupported.js").BuildObjectForNamespace("ua.uri.selector"));
        registry.add(require("./elements/ua.wizard.js"));
    module.exports = registry;
    